<template >
<div>
<form v-on:submit.prevent="submit()">
  <div class="form-group row">
    <label for="staticEmail" class="col-sm-2 col-form-label">Utente</label>
    <div class="col-sm-10">
      <span class="badge badge-light" role="status" aria-hidden="true">
       <strong> {{currentUser }} </strong>  
      </span>
      <!--<input type="text" readonly class="form-control-plaintext" id="staticUser" v-model="currentUser" >-->
    </div>
  </div>
  <div class="form-group row">
    <label for="inputPassword" class="col-sm-2 col-form-label">Vecchia Password</label>
    <div class="col-sm-10">
      <div class="input-group-prepend">
          <div class="input-group-text">
            <i class='far fa-edit'></i>
          </div>
      <input required autocomplete="off" type="password" class="form-control" id="inputPassword" v-model="password.old">
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label for="inputPassword1" class="col-sm-2 col-form-label">Nuova Password</label>
    <div class="col-sm-10">
      <div class="input-group-prepend">
      <div class="input-group-text">
            <i class='fas fa-edit'></i>
          </div>
      <input required autocomplete="off" type="password" class="form-control mr-2" id="inputPassword1" v-model="password.new1">
      <small id="passwordHelpInline" class="text-muted">
      Deve contenere almeno 6 caratteri
    </small>
      </div>
    </div>
  </div>
  <div class="form-group row">
    <label for="inputPassword2" class="col-sm-2 col-form-label">Ripeti Password</label>
    <div class="col-sm-10">
      <div class="input-group-prepend">
      <div class="input-group-text">
            <i class='fas fa-edit'></i>
          </div>
      <input required autocomplete="off" type="password" class="form-control mr-2" id="inputPassword2" v-model="password.new2">
      <small id="passwordHelpInline" class="text-muted">
      Deve contenere almeno 6 caratteri
    </small>
      </div>
    </div>
  </div>
  
  
  <button type="submit" class="btn btn-success float-right">
    <i  class="fas fa-user-edit mr-2" aria-hidden="true"></i>
    MODIFICA</button>

</form>
<alert-box @close="msg.title=''" v-bind:msg="msg" class="mt-2"  ></alert-box>
</div>
</template>
<script>


import api from '@/api'
import alertBox from '@/components/common/AlertBox.vue';
import { mapGetters }  from 'vuex';
export default {
  components: {alertBox},
  
 data () {
    return {

    password : {},
    msg : {
        title : '',
        body  : '',
        type  : 0
      }


    }
  },
  directives: 
    {
      focus: {
      
        inserted: function (el) {
          
          el.focus()
          }
           
       
      }
    },
  computed: {
    ...mapGetters(['company','userId','currentUser']) 
  },
mounted()
{

 this.getData()
  
  
},  
created()
{
  
},
methods :{

async submit()
{
  this.msg.title = ''
  if(this.password.password != this.password.old)
  {
      this.msg.title = 'ATTENZIONE '
      this.msg.body  = 'Password utente errata.'
      this.msg.type  = 1
      return
  }

  if(this.password.new1.length < 6  || this.password.new2.length < 6 )
  {
    this.msg.title = 'ATTENZIONE '
    this.msg.body  = 'Lunghezza nuova password errata.'
    this.msg.type  = 1
    return
  }
  if(this.password.new1 != this.password.new2)
  {
    this.msg.title = 'ATTENZIONE '
    this.msg.body  = 'Le password digitate non sono uguali.'
    this.msg.type  = 1
    return
  }
  
  
  let sp    = {'sp' : 'spUpdateUserPassword'}
  let data  = {'userId' : this.userId,'password':this.password.new1}
  let json  = Object.assign(data, sp)
  
  

  this.spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {

              this.password = {}
              this.msg.title = 'PASSWORD MODIFICATA. '
              this.msg.body = ''
              this.msg.type  = 0

                 
                         
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},

async getData()
{

  
  
  this.msg.title = ''
  let sp    = {'sp' : 'spUserPassword'}
  let data  = {'userId' : this.userId}
  let json  = Object.assign(data, sp)
  
  

  this.spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {

              
              this.password.password = res.data.recordsets[0][0].password
              
                 
                         
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.spinner = false
        });


},



}

}

</script>
<style scoped>

.badge-light
{
  font-size: 20px;
}
</style>
